export const DEFAULT_SAVE_ERROR = 'Could not save form. Please try again.';

export const FORM_NAME_REQUIRED_ERROR = 'Form.io form name is required';

export const FORM_LOAD_ERROR = 'Could not load form.';

export const FORM_UPDATED_SUCCESS = 'Form updated successfully.';

export const FORM_CREATED_SUCCESS = 'Form created successfully.';
